<input
  #sensorImageInput
  type="file"
  class="remove"
  accept="image/*"
  (change)="fileChanged('sensor', $event)"
/>
<input
  #equipmentImageInput
  type="file"
  class="remove"
  accept="image/*"
  (change)="fileChanged('equipment', $event)"
/>
@if (!saving()) {
  @switch (stage()) {
    @case (stages.match) {
      <div [class.mobile]="isMobile()" class="main">
        <app-header
          [transparent]="true"
          [wizard]="true"
          (wizardButtonClick)="onHeaderNavigation($event)"
          [wizardsteps]="getHeaderSteps()"
          [currentstep]="0"
        >
        </app-header>
        <button class="exit-button" (click)="overlayExitPopup.set(true)">
          <i nz-icon [nzType]="'icons:exit'" class="svg-icon"></i>
        </button>
        <app-match-equipment
          [counter]="counter"
          (overlayExitPopupEvent)="overlayExitPopup.set(false)"
          (navExit)="overlayExitPopup.set(true)"
          (navContinue)="topScroll('photo')"
          [assetId]="assetId()"
        >
        </app-match-equipment>
      </div>
    }

    @case (stages.photo) {
      <div [class.mobile]="isMobile()">
        <app-header
          [transparent]="true"
          [wizard]="true"
          (wizardButtonClick)="onHeaderNavigation($event)"
          [wizardsteps]="getHeaderSteps()"
          [start]="0"
          [currentstep]="1"
        >
        </app-header>
        <button class="exit-button" (click)="overlayExitPopup.set(true)">
          <i nz-icon [nzType]="'icons:exit'" class="svg-icon"></i>
        </button>
        <div class="content stageThree">
          <i nz-icon [nzType]="'icons:camera'" class="svg-icon big-icon"></i>
          <h1>
            {{
              isMobile()
                ? i18n.langString("sensor_step_3_mobile")
                : i18n.langString("sensor_step_3")
            }}
          </h1>

          <div class="innercontent two-columns-flex">
            <div class="photo-hint-wrapper" #photoid>
              @if (isMobile()) {
                <h2>
                  {{ i18n.langString("photo_hint_sensor_header_mobile") }}
                </h2>
              } @else {
                <h2 class="upper-header">
                  {{ i18n.langString("photo_hint_sensor_header") }}
                </h2>
                <h2>{{ i18n.langString("photo_hint_sensor_header_2") }}</h2>
              }

              <span class="black-coral-text">
                {{
                  hasCamera
                    ? i18n.langString("photo_hint_sensor_camera")
                    : i18n.langString("photo_hint_sensor")
                }}
              </span>

              <app-marker-image
                [image]="sensorPhoto().imagePreview"
                [useDefaultImage]="sensorPhoto().useDefaultImage"
                [defaultImage]="sensorPhoto().defaultImage"
                [markers]="sensorPhoto().markers"
                [sensorMarkerPlaced]="true"
                (addImageClicked)="addImage('sensor')"
                (editImageClicked)="stage.set(stages.photoSensorEdit)"
                (useDefaultImageClicked)="loadDefaultImage('sensor')"
                (imageLoaded)="onImageLoaded('sensor', $event)"
              >
              </app-marker-image>
            </div>

            <span class="vertical-line"></span>

            <div class="photo-hint-wrapper-2" #photoView>
              @if (isMobile()) {
                <h2>
                  {{ i18n.langString("photo_hint_equipment_header_mobile") }}
                </h2>
              } @else {
                <h2 class="upper-header">
                  {{ i18n.langString("photo_hint_equipment_header") }}
                </h2>
                <h2>{{ i18n.langString("photo_hint_equipment_header_2") }}</h2>
              }

              <span class="black-coral-text">
                {{
                  hasCamera
                    ? i18n.langString("photo_hint_equipment_camera")
                    : i18n.langString("photo_hint_equipment")
                }}
              </span>

              <app-marker-image
                [image]="equipmentPhoto().imagePreview"
                [useDefaultImage]="equipmentPhoto().useDefaultImage"
                [defaultImage]="equipmentPhoto().defaultImage"
                [markers]="equipmentPhoto().markers"
                [sensorMarkerPlaced]="sensorMarkerPlaced"
                (addImageClicked)="
                  sensorMarkerPlaced = true; addImage('equipment')
                "
                (editImageClicked)="stage.set(stages.photoAssetEdit)"
                (markImageClicked)="
                  sensorMarkerPlaced = true; stage.set(stages.photoAssetEdit)
                "
                (useDefaultImageClicked)="loadDefaultImage('equipment')"
                (imageLoaded)="onImageLoaded('equipment', $event)"
              >
              </app-marker-image>
            </div>
          </div>
        </div>
      </div>
    }

    @case (stages.photoSensorCrop) {
      <app-image-crop
        [fileEvent]="fileEvent"
        (imageSaved)="confirmImageCrop($event)"
        (navBack)="cancelUploadImageCrop()"
        (clickExit)="overlayExitPopup.set(true)"
      ></app-image-crop>
    }

    @case (stages.photoSensorEdit) {
      <div [class.mobile]="isMobile()">
        <button
          class="exit-button noHeader"
          (click)="overlayExitPopup.set(true)"
        >
          <i nz-icon [nzType]="'icons:exit'" class="svg-icon"></i>
        </button>
        <div class="content mobileBigFooterContent">
          <div class="title-without-icon">
            <h4>{{ i18n.langString("mark_sensor") }}</h4>
          </div>
          <app-dragdrop-marker-image
            [image]="
              sensorPhoto().useDefaultImage
                ? sensorPhoto().defaultImage
                : sensorPhoto().imagePreview
            "
            [markers]="sensorPhoto().markers"
            [wide]="true"
            (imageLoaded)="onImageLoaded('sensor', $event)"
          >
          </app-dragdrop-marker-image>
          <app-nav-button
            [lighttertiary]="true"
            [svgIcon]="'icons:camera'"
            [wide]="false"
            [smol]="true"
            class="btn-not-wide"
            (clickEvent)="addImage('sensor')"
            >{{ i18n.langString("change_photo") }}</app-nav-button
          >
        </div>
      </div>
    }

    @case (stages.location) {
      <div [class.mobile]="isMobile()">
        <app-header
          [transparent]="true"
          [wizard]="true"
          (wizardButtonClick)="onHeaderNavigation($event)"
          [wizardsteps]="getHeaderSteps()"
          [start]="0"
          [currentstep]="2"
        ></app-header>
        <button class="exit-button" (click)="overlayExitPopup.set(true)">
          <i nz-icon [nzType]="'icons:exit'" class="svg-icon"></i>
        </button>
        <div class="content content-wide not-padded map-content">
          <div class="padded">
            <i
              nz-icon
              [nzType]="'icons:location'"
              class="svg-icon big-icon"
            ></i>
            <h1>{{ i18n.langString("sensor_step_4") }}</h1>
            <span class="black-coral-text">{{
              i18n.langString("location_hint")
            }}</span>
          </div>
          <app-embedded-sensor-map
            (exit)="overlayExitPopup.set(true)"
            (positionChanged)="onPositionChanged($event)"
          >
          </app-embedded-sensor-map>
        </div>
      </div>
    }

    @case (stages.end) {
      <div [class.mobile]="isMobile()">
        <app-header [transparent]="true"></app-header>
        <div class="content content-wide">
          <i nz-icon [nzType]="'icons:fixed'" class="svg-icon big-icon"></i>
          <h1>{{ i18n.langString("match_sensor_success") }}</h1>
          <span class="black-coral-text">
            {{ i18n.langString("match_sen") }}
            <b>"{{ asset()?.objectName }}"</b>
            {{ i18n.langString("sensor_success_hint") }}
          </span>
          <div class="innercontent two-columns-flex last-info-page">
            <div>
              <h4>{{ i18n.langString("ST_last_page_question_1") }}</h4>
              <app-nav-button
                [primary]="true"
                [svgIcon]="'icons:plant'"
                [fullwidth]="true"
                (clickEvent)="onNavBack()"
              >
                {{ i18n.langString("back_to_plant") }}
              </app-nav-button>
            </div>
            <span class="vertical-line"></span>
            <div>
              <h4>{{ i18n.langString("question_match_sensor") }}</h4>
              <app-nav-button
                [darksecondary]="true"
                [svgIcon]="'icons:associated-equipment'"
                [fullwidth]="true"
                (clickEvent)="onNavToEM()"
                >{{ i18n.langString("check_installed_sensor") }}</app-nav-button
              >
            </div>
          </div>
        </div>
      </div>
    }
  }
} @else {
  <div [class.mobile]="isMobile()">
    <app-header [transparent]="true"></app-header>
    <div class="content">
      <div class="spinner-container">
        <app-spinner [black]="true"></app-spinner>
      </div>
    </div>
  </div>
}

<app-footer [class.mobile]="isMobile()">
  @if (stage() === stages.match) {
    <div class="footer-inner-wrapper">
      @if (isMobile()) {
        <app-nav-button
          [svgIcon]="'icons:arrow-left'"
          (clickEvent)="stage.set(stages.match)"
          [onlyIcon]="true"
          class="btn-not-wide"
          [darksecondary]="true"
        ></app-nav-button>
      }
      <app-nav-button
        [svgIconRight]="'icons:arrow-right'"
        [disabled]="!isMatchComplete()"
        (clickEvent)="topScroll('photo')"
        [primary]="true"
        style="
          margin-left: 16px;
          display: flex;
          justify-content: flex-end;
          width: 100%;
        "
      >
        {{ i18n.langString("continue") }}
      </app-nav-button>
    </div>
  }

  @if (stage() === stages.photo) {
    <div class="footer-inner-wrapper flex-display">
      <app-nav-button
        [svgIcon]="'icons:arrow-left'"
        [darksecondary]="true"
        (clickEvent)="stage.set(stages.match)"
        [smol]="!isMobile()"
      >
        {{ i18n.langString("go_back") }}
      </app-nav-button>

      <app-nav-button
        [svgIconRight]="'icons:arrow-right'"
        [disabled]="
          (!sensorPhoto().imagePreview && !sensorPhoto().useDefaultImage) ||
          (!equipmentPhoto().imagePreview && !equipmentPhoto().useDefaultImage)
        "
        (clickEvent)="topScroll('location')"
        [primary]="true"
        style="margin-left: 16px"
      >
        {{ i18n.langString("continue") }}
      </app-nav-button>
    </div>
  }

  @if (
    stage() === stages.photoSensorEdit || stage() === stages.photoAssetEdit
  ) {
    <div class="footer-inner-wrapper mobileColumnWrapper">
      <span class="black-text">{{ i18n.langString("drag_pin") }}</span>
      <app-nav-button
        class="mobileFlex1"
        [svgIcon]="'icons:fixed'"
        (clickEvent)="confirmImageMarker()"
        [primary]="true"
      >
        {{ i18n.langString("confirm_sensor_position") }}
      </app-nav-button>
    </div>
  }

  @if (stage() === stages.location) {
    <div class="footer-inner-wrapper flex-display location">
      <app-nav-button
        [svgIcon]="'icons:arrow-left'"
        [darksecondary]="true"
        (clickEvent)="stage.set(stages.photo)"
        [smol]="!isMobile()"
      >
        {{ i18n.langString("go_back") }}
      </app-nav-button>

      @if (!saving()) {
        <app-nav-button
          [disabled]="!isSensorComplete()"
          class="mobileFlex1"
          [svgIcon]="'icons:save'"
          (clickEvent)="createSensor()"
          [primary]="true"
        >
          {{ i18n.langString("finish_sensor") }}
        </app-nav-button>
      } @else {
        <app-spinner [black]="true"></app-spinner>
      }
    </div>
  }
</app-footer>

@if (overlayExitPopup()) {
  <app-exit-creation-popup
    (closeEvent)="onExit($event)"
  ></app-exit-creation-popup>
}
